import {
  Button,
  FormControl,
  FormControlProps,
  FormHelperText,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  SelectProps,
  Typography,
} from "@material-ui/core";
import { ArrowDropDownCircle } from "@material-ui/icons";
import React from "react";
import { QueryResponse } from "react-fetching-library";
import { theme } from "../../constants/theme";
import { Account } from "../../validations/entities";

const iconComponent = (props: { className: string }) => {
  return <ArrowDropDownCircle className={props.className} />;
};

const AccountSelect = ({
  loading,
  error,
  onReload,
  accounts,
  formControlProps,
  selectProps,
  helperText,
}: {
  loading: boolean;
  error: boolean;
  onReload: () => Promise<QueryResponse<Account[]>>;
  accounts?: Account[];
  formControlProps?: FormControlProps;
  selectProps?: SelectProps;
  helperText?: string;
}) => {
  return (
    <FormControl {...formControlProps} size="small">
      {loading && <LinearProgress title="Getting Accounts" />}
      {error && (
        <>
          <Typography>There was a problem getting the accounts.</Typography>
          <Button color="secondary" onClick={onReload}>
            Retry
          </Button>
        </>
      )}
      {!loading && !error && accounts && (
        <>
          <InputLabel>Select Account</InputLabel>
          <Select {...selectProps} IconComponent={iconComponent}>
            {accounts.map((account, index) => (
              <MenuItem
                key={`account-${account}-${index}`}
                value={`${account.accountId};${account.accountNum}`}
              >
                {`${account.accountNum} - ${account.accountNickname}`}
              </MenuItem>
            ))}
          </Select>
        </>
      )}
      {helperText && (
        <FormHelperText
          margin="dense"
          style={{ fontSize: theme.typography.pxToRem(10) }}
        >
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default AccountSelect;
